import React from 'react';

const LoadingCustom = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <svg
        className="container"
        x="0px"
        y="0px"
        viewBox="0 0 37 37"
        height="37"
        width="37"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          className="track"
          fill="none"
          strokeWidth="5"
          pathLength="100"
          d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
        />
        <path
          className="car"
          fill="none"
          strokeWidth="5"
          pathLength="100"
          d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
        />
      </svg>
      <style>
        {`
          .container {
            --uib-size: 37px;
            --uib-color: #01793B; /* Mengganti warna */
            --uib-speed: 0.35s; /* Mengganti kecepatan */
            --uib-bg-opacity: .1;
            height: var(--uib-size);
            width: var(--uib-size);
            transform-origin: center;
            overflow: visible;
          }

          .car {
            fill: none;
            stroke: var(--uib-color);
            stroke-dasharray: 15, 85;
            stroke-dashoffset: 0;
            stroke-linecap: round;
            animation: travel var(--uib-speed) linear infinite;
            will-change: stroke-dasharray, stroke-dashoffset;
            transition: stroke 0.5s ease;
          }

          .track {
            stroke: var(--uib-color);
            opacity: var(--uib-bg-opacity);
            transition: stroke 0.5s ease;
          }

          @keyframes travel {
            0% {
              stroke-dashoffset: 0;
            }

            100% {
              stroke-dashoffset: -100;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingCustom;
